{
  "pageTitle": "Import dostępności",
  "pageSubtitle": "Wgraj plik z oknami czasowymi dostępności nośników — import nie zmienia atrybutów nośnika (typ, wymiary, cena)",
  "accessDenied": "Brak dostępu do importu dostępności",
  "stepper": {
    "upload": "Prześlij plik",
    "headerRow": "Wiersz nagłówka",
    "preview": "Podgląd",
    "result": "Wynik"
  },
  "upload": {
    "dropZoneTitle": "Przeciągnij plik lub kliknij, aby wybrać",
    "dropZoneSubtitle": "Obsługiwany format: .xlsx, .xls, .xlsm, maks. 10 MB",
    "selectFile": "Wybierz plik",
    "scopeNote": "Ten import zapisuje wyłącznie fakty dostępności w podanych oknach czasowych (np. wolne / zarezerwowane). Nie modyfikuje danych samego nośnika.",
    "nextButton": "Dalej",
    "uploading": "Przesyłanie...",
    "errorInvalidFileType": "Nieobsługiwany format pliku. Dozwolone formaty: .xlsx, .xls, .xlsm"
  },
  "headerRow": {
    "heading": "Wiersz nagłówka",
    "helperText": "Wskaż, który wiersz w pliku zawiera prawdziwe nazwy kolumn. Automatyczne wykrywanie może pomylić się, gdy nad tabelą znajduje się notatka lub nagłówek firmowy.",
    "rowNumberHeader": "Wiersz",
    "previewHeading": "Podgląd: nagłówek i przykładowy wiersz danych",
    "previewHeaderRowLabel": "Nagłówek",
    "previewSampleRowLabel": "Przykładowy wiersz danych",
    "previewNoSampleRow": "Brak wiersza danych bezpośrednio pod wybranym wierszem",
    "emptyCellPlaceholder": "—",
    "emptyRowPlaceholder": "Wybierz wiersz powyżej",
    "headerAutoNoteDetectedTemplate": "Nagłówek: wiersz {row} (wykryto automatycznie)",
    "headerAutoNoteManualTemplate": "Nagłówek: wiersz {row} (wybrano ręcznie)",
    "headerAutoInfoLabel": "Informacja o wykrywaniu nagłówka",
    "headerAutoInfoText": "System automatycznie wybiera pierwszy wiersz z co najmniej dwiema niepustymi komórkami. Jeśli plik ma notatkę lub nagłówek firmowy nad tabelą, wybierz właściwy wiersz w tabeli poniżej.",
    "fileSummaryTemplate": "{sizeKb} KB · ~{rows} wierszy",
    "fileSummaryTemplateRowsOnly": "~{rows} wierszy",
    "sheetPickerLabel": "Arkusz",
    "back": "Wstecz",
    "nextButton": "Dalej",
    "loading": "Wczytywanie…"
  },
  "preview": {
    "heading": "Rozpoznany profil pliku",
    "helperText": "Sprawdź i popraw dopasowanie kolumn w razie potrzeby",
    "confidentBadge": "Wysoka pewność dopasowania",
    "lowConfidenceBadge": "Niska pewność dopasowania — sprawdź poniższe pola",
    "supplierLabel": "Dostawca",
    "supplierPlaceholder": "Wybierz dostawcę…",
    "supplierNumberColumnLabel": "Numer dostawcy",
    "columnPlaceholder": "Wybierz kolumnę…",
    "columnMappingTableSystemFieldHeader": "Pole w systemie",
    "columnMappingTableFileColumnHeader": "Kolumna w pliku",
    "columnMappingTableSampleValueHeader": "Przykład z pliku",
    "columnMappingTableSampleEmptyPlaceholder": "—",
    "columnMappingOptionalTag": "opcjonalne",
    "columnMappingClearOption": "— brak —",
    "timeEncodingLabel": "Sposób zapisu dostępności",
    "timeEncodingOptions": {
      "global": "Jeden zakres dat dla całego pliku",
      "date_range": "Kolumny z datą od/do w każdym wierszu",
      "period_label_map": "Kolumna z opisem okresu (zmapuj wartości na daty)",
      "month": "Kolumny okresów — zbuduj ręcznie"
    },
    "timeEncodingHelp": {
      "triggerLabel": "Wyjaśnij sposoby zapisu dostępności",
      "dialogTitle": "Sposoby zapisu dostępności w pliku",
      "globalTitle": "Jeden zakres dat dla całego pliku",
      "globalExplanation": "Plik nie zawiera żadnych kolumn z datami — wskazujesz ręcznie jeden zakres dat dla całego pliku, a każdy nośnik z listy otrzyma dokładnie ten sam okres dostępności. Sam zakres dat bywa opisany np. w nazwie pliku lub w wiadomości od dostawcy, tak jak tutaj.",
      "globalExampleFileName": "Oferta_Lublin_czerwiec_2026.xlsx",
      "globalExampleHeader1": "Numer dostawcy",
      "globalExampleHeader2": "Adres",
      "globalExampleHeader3": "Status",
      "globalExampleRow1Cell1": "LL-070-01",
      "globalExampleRow1Cell2": "ul. Krakowskie Przedmieście 5",
      "globalExampleRow1Cell3": "Wolne",
      "dateRangeTitle": "Kolumny z datą od/do w każdym wierszu",
      "dateRangeExplanation": "Każdy nośnik (wiersz) ma własną parę kolumn z datą początku i końca dostępności — system odczytuje je bezpośrednio, bez ręcznego uzupełniania zakresu.",
      "dateRangeExampleHeader1": "Numer dostawcy",
      "dateRangeExampleHeader2": "Data od",
      "dateRangeExampleHeader3": "Data do",
      "dateRangeExampleHeader4": "Status",
      "dateRangeExampleRow1Cell1": "LL-070-01",
      "dateRangeExampleRow1Cell2": "01.06.2026",
      "dateRangeExampleRow1Cell3": "15.06.2026",
      "dateRangeExampleRow1Cell4": "Wolne",
      "periodLabelMapTitle": "Kolumna z opisem okresu",
      "periodLabelMapExplanation": "Zamiast konkretnych dat plik ma jedną kolumnę ze słownym opisem okresu (np. nazwą miesiąca) — Ty ręcznie przypisujesz każdemu takiemu opisowi właściwy zakres dat, jeden raz na cały plik.",
      "periodLabelMapExampleHeader1": "Numer dostawcy",
      "periodLabelMapExampleHeader2": "Termin",
      "periodLabelMapExampleRow1Cell1": "LL-070-01",
      "periodLabelMapExampleRow1Cell2": "cały czerwiec",
      "monthTitle": "Kolumny okresów — zbuduj ręcznie",
      "monthExplanation": "Plik ma osobną kolumnę dla każdego okresu (całego miesiąca lub jego połowy), a w komórkach — wartość statusu nośnika w tym okresie. System nie rozpoznał automatycznie, co oznaczają nagłówki tych kolumn (np. rzymskie numery miesięcy) — Ty ręcznie wskazujesz, która kolumna pliku odpowiada któremu okresowi, i podajesz jego dokładny zakres dat. Pełne miesiące i połówki miesiąca możesz dowolnie mieszać w tym samym pliku.",
      "monthExampleHeader1": "Symbol",
      "monthExampleHeader2": "VI",
      "monthExampleHeader3": "1-15 VII",
      "monthExampleHeader4": "16-31 VII",
      "monthExampleHeader5": "VIII",
      "monthExampleRow1Cell1": "LL-070-01",
      "monthExampleRow1Cell2": "rwnj",
      "monthExampleRow1Cell3": "rwnj",
      "monthExampleRow1Cell4": "w ofercie",
      "monthExampleRow1Cell5": "rwnj"
    },
    "statusColumnLabel": "Status",
    "dateFromColumnLabel": "Data od",
    "dateToColumnLabel": "Data do",
    "dateFormatLabel": "Format daty",
    "dateFormatCustomPlaceholder": "dd.MM.yyyy",
    "dateFormatCustomHelperText": "np. dd.MM.yyyy, yyyy/MM/dd",
    "dateFormatOptions": {
      "auto": "Auto-wykryto",
      "dd-mm-yyyy": "DD.MM.RRRR",
      "yyyy-mm-dd": "RRRR-MM-DD",
      "excel-serial": "Numer seryjny Excel",
      "custom": "Niestandardowy…"
    },
    "monthPeriodSectionLabel": "Kolumny okresów",
    "monthPeriodPeriodColumnLabel": "Okres",
    "monthPeriodSourceColumnLabel": "Kolumna źródłowa",
    "monthPeriodYearColumnLabel": "Rok",
    "monthPeriodAddRowLabel": "Dodaj okres",
    "monthPeriodRemoveRowLabel": "Usuń okres",
    "monthPeriodEmptyStateText": "Brak zdefiniowanych okresów — dodaj pierwszy, aby zmapować kolumny pliku",
    "monthPeriodManualRowLabelTemplate": "Okres {count}",
    "statusTokenMappingHeading": "Mapowanie wartości statusu",
    "statusTokenMappingHelperText": "Plik używa własnych oznaczeń zajętości. Wskaż, co każde z nich oznacza w systemie — niezmapowane wartości zostaną pominięte przy imporcie.",
    "statusTokenMappingTokenHeader": "Wartość z pliku",
    "statusTokenMappingOccurrenceHeader": "Liczba wystąpień",
    "statusTokenMappingStateHeader": "Stan w systemie",
    "statusTokenMappingStatePlaceholder": "Wybierz stan",
    "statusTokenMappingUnmappedBadge": "Niezmapowane",
    "dateRangePlaceholder": "Wybierz zakres dat…",
    "dateRangeColumnLabel": "Od - Do",
    "globalRangeSectionLabel": "Zakres dat dla całego pliku",
    "periodLabelColumnLabel": "Kolumna z opisem okresu",
    "periodLabelSectionLabel": "Zmapuj wartości okresu na daty",
    "periodLabelValueColumnLabel": "Wartość w pliku",
    "markRestUnavailableLabel": "Oznacz pozostałe nośniki tego dostawcy jako niedostępne w tym okresie",
    "markRestUnavailableNoteTemplate": "+ {count} innych nośników dostawcy {supplier} zostanie oznaczonych jako niedostępne w tym okresie",
    "disabledGlobalRangeReason": "Uzupełnij zakres dat, aby zatwierdzić",
    "disabledPeriodLabelReason": "Zmapuj wszystkie wartości okresu, aby zatwierdzić",
    "disabledSupplierReason": "Wybierz dostawcę, aby zatwierdzić",
    "disabledMonthPeriodReason": "Uzupełnij zakres dat dla każdego okresu, aby zatwierdzić",
    "disabledDateRangeReason": "Wybierz kolumny z datą od i do, aby zatwierdzić",
    "back": "Wstecz",
    "confirm": "Zatwierdź",
    "confirming": "Zatwierdzanie…",
    "rowsUnitColumnLabel": "Nośnik",
    "rowsPeriodColumnLabel": "Okres",
    "rowsStatusColumnLabel": "Status",
    "rowsStatusValues": {
      "FREE": "Wolne",
      "UNAVAILABLE": "Niedostępne"
    },
    "rowsUnmatchedTemplate": "Niedopasowany ({unit})",
    "rowsUnmatchedTooltip": "Nie znaleziono nośnika dla tego dostawcy i numeru",
    "rowsEmptyPlaceholder": "—",
    "rematchFailedWarning": "Nie udało się ponownie dopasować wierszy do nośników po zmianie — wyniki dopasowania mogą być nieaktualne. Spróbuj ponownie zmienić pole lub odśwież stronę.",
    "rememberedMappingHeading": "Zapamiętane mapowanie",
    "rememberedMappingDateTemplate": "z {date}",
    "rememberedMappingNoDateFallback": "z poprzedniego importu",
    "rememberedMappingResetLabel": "Wyczyść mapowanie",
    "addressFieldLabel": "Adres",
    "cityFieldLabel": "Miasto",
    "unmatchedMappingWarningText": "Żaden wiersz nie został dopasowany do nośnika. Sprawdź mapowanie dostawcy, numeru, adresu i miasta w sekcji „Rozpoznany profil pliku”.",
    "yearSpanWarningText": "Miesiące z pliku zostały przypisane do dwóch różnych lat. Sprawdź rozpoznane lata w tabeli okresów przed zatwierdzeniem importu.",
    "disabledUnmatchedMappingReason": "Popraw mapowanie kolumn, aby zatwierdzić"
  },
  "result": {
    "polling": "Przetwarzanie pliku…",
    "headingSuccess": "Import zakończony",
    "subtitleSuccess": "Plik z dostępnością nośników został przetworzony",
    "statUpdated": "Zaktualizowano",
    "statUnchanged": "Bez zmian",
    "statUnmatched": "Niedopasowane",
    "downloadUnmatchedReport": "Pobierz raport niedopasowanych (CSV)",
    "downloadReportFailed": "Nie udało się pobrać raportu niedopasowanych wierszy",
    "finish": "Zakończ",
    "headingFailure": "Import nie powiódł się",
    "failureNote": "Żadne wiersze nie zostały zapisane. Dane dostępności pozostały bez zmian.",
    "retry": "Spróbuj ponownie",
    "errorReportColumnRow": "Wiersz",
    "errorReportColumnGrwId": "Numer GRW",
    "errorReportColumnField": "Pole",
    "errorReportColumnMessage": "Komunikat",
    "errorReportColumnSeverity": "Waga",
    "errorReportColumnSupplierNumber": "Numer dostawcy",
    "errorReportColumnSupplierName": "Dostawca",
    "errorReportColumnLatitude": "Szerokość",
    "errorReportColumnLongitude": "Długość",
    "errorReportColumnAddress": "Adres",
    "errorReportColumnCity": "Miasto"
  },
  "toasts": {
    "sessionLost": "Dane podglądu zostały utracone — prześlij plik ponownie.",
    "periodLabelMapIncomplete": "Nie wszystkie okresy zostały zmapowane na daty — sprawdź tabelę mapowania.",
    "globalPeriodRequired": "Uzupełnij zakres dat dla całego pliku, aby zatwierdzić.",
    "markRestUnavailableOutOfScope": "Oznaczanie pozostałych nośników jako niedostępnych jest dostępne tylko dla plików z zakresem dat dla całego pliku i listą wolnych nośników.",
    "dateRangeColumnsRequired": "Wybierz kolumny z datą od i do, aby zatwierdzić.",
    "supplierNotResolvable": "Wybierz kolumnę z dostawcą lub podaj domyślnego dostawcę, aby zatwierdzić.",
    "monthPeriodColumnsIncomplete": "Uzupełnij zakres dat dla każdego okresu, aby zatwierdzić.",
    "allRowsUnmatched": "Żaden wiersz nie został dopasowany do nośnika — popraw mapowanie kolumn przed zatwierdzeniem."
  }
}
